// globals
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
class AccordionEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(".s-qa__question").on('click', function() {
      $(this).toggleClass('is-active').next().slideToggle();
      $(".s-qa__answer").toggleClass('is-active');
    });
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FixCtaEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const fixCta = document.querySelector('.c-fixCta');

    function toggleFixCtaClass() {
      if (window.scrollY >= 400) {
        fixCta.classList.add('is-active');
      } else {
        fixCta.classList.remove('is-active');
      }
    }

    window.addEventListener('scroll', toggleFixCtaClass);
    toggleFixCtaClass();
    

    // 要素を取得
    const $ctaElement = $('.c-fixCta');
    const $formElement = $('.s-form');

    if ($ctaElement.length === 0 || $formElement.length === 0) return; // 要素が存在しない場合は終了

    // スクロールイベントリスナーを追加
    $(window).on('scroll', function() {
        // s-formの位置を取得
        const formTop = $formElement.offset().top;

        // 現在のスクロール位置を取得
        const scrollPosition = $(window).scrollTop();

        // c-fixCtaがs-formに到達したかどうかを判定
        if (scrollPosition >= formTop) {
            $ctaElement.addClass('is-hidden');
        } else {
            $ctaElement.removeClass('is-hidden');
        }
    });
  }
}

class FormCheckbox {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const checkBoxes = document.querySelectorAll('.mwform-checkbox-field-text');

    // 2番目の要素に対して変更を加える
    if (checkBoxes.length > 16) {
      checkBoxes[16].innerHTML = '<a href="https://dokusogan.jp/yamatei/privacy-policy/" name="consent" target="_blank" class="policy-link">「プライバシーポリシー」</a>に同意する';
    }
  }
}

//noScroll
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // 全角から半角
    function replaceZtoH(str) {
      str = str.replace(/[！-～]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }

    // js-convert クラスを持つすべての要素を取得
    const elements = document.querySelectorAll('.js-convert');

    // 各要素に blur イベントリスナーを追加
    elements.forEach(el => {
      el.addEventListener('blur', () => {
        const br = el.value;
        const ar = replaceZtoH(br);
        el.value = ar;
      });
    });

  }
}

class FormDisabled {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    var agreementCheckbox = document.getElementById('agreement-1');

    function handleCheckboxChange() {
        var mainForm = document.querySelector('.s-form__main');

        if (agreementCheckbox.checked) {
            mainForm.classList.remove('disabled');
        } else {
            mainForm.classList.add('disabled');
        }
    }
    agreementCheckbox.addEventListener('change', handleCheckboxChange);
    handleCheckboxChange();

    // 空のpタグを削除
    var paragraphs = document.querySelectorAll('p');
    paragraphs.forEach(function (paragraph) {
      if (paragraph.textContent.trim() === '') {
          paragraph.remove();
      }
    });
  }
}

class HamburgerEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const btn  = document.querySelector(".l-header__hum");
    const humMenu  = document.querySelector(".humMenu");
    const html  = document.querySelector("html");

    btn.addEventListener("click", () => {
      btn.classList.toggle("is-active");
      humMenu.classList.toggle("is-active");
      html.classList.toggle("is-hidden");
    })
  }
}

class HeaderScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const header = document.querySelector('.l-header__hum');
    const mvSection = document.querySelector('.s-mv');
  
    function toggleHeaderClass() {
      const mvRect = mvSection.getBoundingClientRect();
      if (mvRect.bottom <= 0) {
        header.classList.add('is-color');
      } else {
        header.classList.remove('is-color');
      }
    }
  
    window.addEventListener('scroll', toggleHeaderClass);
    toggleHeaderClass();
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}
new ScrollHint('.js-scrollable', {
  applyToParents: true,
  remainingTime: 5000,
  i18n: {
      scrollable: 'スクロールできます'
  }
});
class SmoothScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const headerHeight = $('.l-header').outerHeight();
    const urlHash = location.hash;
    const btn  = document.querySelector(".l-header__hum");
    const humMenu  = document.querySelector(".humMenu");
    const html  = document.querySelector("html");

    if (window.matchMedia('(max-width: 767px)').matches) {
      if(urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
          const target = $(urlHash);
          const position = target.offset().top - headerHeight;
          $('body,html').stop().animate({scrollTop:position}, 500);
        }, 100);
      }
      $('a[href^="#"]').click(function(){
        const href= $(this).attr("href");
        const target = $(href);
        const position = target.offset().top + -10;
        btn.classList.remove("is-active")
        humMenu.classList.remove("is-active")
        html.classList.remove("is-hidden")
        $('body,html').stop().animate({
          scrollTop:position
        }, 500);
        return false;
      });

    } else if (window.matchMedia('(min-width:768px)').matches) {

      if(urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
          const target = $(urlHash);
          const position = target.offset().top - headerHeight;
          $('body,html').stop().animate({scrollTop:position}, 500);
        }, 100);
      }
      $('a[href^="#"]').click(function(){
        const href= $(this).attr("href");
        const target = $(href);
        const position = target.offset().top;
        btn.classList.remove("is-active")
        humMenu.classList.remove("is-active")
        html.classList.remove("is-hidden")
        $('body,html').stop().animate({
          scrollTop:position
        }, 500);
        return false;
      });
    }
  }
}



(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let inviewEvent = new InviewEvent('.js-inview');
  let formConvert = new FormConvert('js-convert');
  let accordionEvent = new AccordionEvent('js-accordion');
  let scrollHint = new ScrollHint('js-scrollable');
  let hamburgerEvent = new HamburgerEvent('js-header');
  let headerScroll = new HeaderScroll('js-header');
  let smoothScroll = new SmoothScroll('js-header');
  let fixCtaEvent = new FixCtaEvent('c-fixCta');
  let formCheckbox = new FormCheckbox('mwform-checkbox-field-text');
  let formDisabled = new FormDisabled('js-convert');
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });